import { apiPrefix } from "../utils/main";
import FetchUtils from "../utils/FetchUtils";

export const projectsPrefix = `${apiPrefix}/projects`;

export async function getDiagnosisCodes(
  projectId: string,
  type: string,
  searchText: string,
  status: string,
) {
  const path = `${projectsPrefix}/${projectId}/diagnosiscodes?type=${type}&searchtext=${searchText}&status=${status}`;

  try {
    const response = await FetchUtils.fetch(path, "GET");
    return (await response.json()) as DiagnosisCodeResponse;
  } catch (error) {
    const genericError = error as Error;
    console.error("Error: ", genericError.toString());
    throw error;
  }
}

export async function getProcedureCodes(
  projectId: string,
  type: string,
  searchText: string,
  status: string,
) {
  const path = `${projectsPrefix}/${projectId}/procedurecodes?type=${type}&searchtext=${searchText}&status=${status}`;

  try {
    const response = await FetchUtils.fetch(path, "GET");
    return (await response.json()) as ProcedureGroupsResponse;
  } catch (error) {
    const genericError = error as Error;
    console.error("Error: ", genericError.toString());
    throw error;
  }
}

export async function updateProjectsFilters(
  projectId: string,
  newData: ProjectFiltersRequest,
) {
  const path = `${projectsPrefix}/${projectId}/filters`;
  try {
    const response = await FetchUtils.fetch(path, "PATCH", newData);
    return await response.json();
  } catch (error) {
    const genericError = error as Error;
    console.error("Error: ", genericError.toString());
    throw error;
  }
}

export type ExportFile =
  | {
      id: CsvFileName;
      label: string;
      requires?: string;
      customCategory?: false;
    }
  | {
      id: string;
      label: string;
      requires?: string;
      customCategory: true;
    };

export async function exportData(
  projectId: string,
  filesOptional: ExportFile[],
) {
  const getPath = () => {
    const url = new URL(`${projectsPrefix}/${projectId}/export`);
    return url.toString();
  };

  const csvFileNames: CsvFileName[] = [];
  const customCategoryIds: string[] = [];

  for (const file of filesOptional) {
    if (!file.customCategory) {
      csvFileNames.push(file.id);
    } else {
      customCategoryIds.push(file.id);
    }
  }

  try {
    const res = await FetchUtils.fetch<ExportRequest>(getPath(), "POST", {
      csvFileNames: csvFileNames,
      exportedCategoryIds: customCategoryIds,
    });
    const fileName = res.headers
      .get("content-disposition")!
      .split(";")
      .find((n) => n.includes("filename="))!
      .replace("filename=", "")
      .replaceAll('"', "")
      .trim();
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
  } catch (error) {
    const genericError = error as Error;
    console.error("Error: ", genericError.toString());
    throw error;
  }
}
